"use strict";

module.exports = {
  /**
   * Get the outer sizes of the given element (offset size + margins)
   * @function
   * @ignore
   * @argument {Element} element
   * @returns {Object} object containing width and height properties
   */
  getOuterSizes: function getOuterSizes(element) {
    // NOTE: 1 DOM access here
    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);
    var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
    var result = { width: rect.width + y, height: rect.height + x };
    return result;
  }
};